import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Box} from 'views/components';
import {AccessTime as AccessTimeIcon} from 'views/icons';

import getStylesByStatus from './getStylesByStatus';

import moment from 'moment';

const MonthlyEventTile = (props) => {
  const {event} = props.event;

  const startTime = moment(event.eventData.startTime).format('hh:mmA');

  const hasShiftConfirmation = !!event.caregiverUpdates.find((e) => e.type === 'shiftConfirmation');
  const hasClockInConfirmation = !!event.caregiverUpdates.find((e) => e.type === 'clockInConfirmation');
  const hasClockOutConfirmationn = !!event.caregiverUpdates.find((e) => e.type === 'clockOutConfirmation');
  const hasRequestedReschedule = !!event.caregiverUpdates.find((e) => e.type === 'requestReschedule');
  const hasRequestedCancel = !!event.caregiverUpdates.find((e) => e.type === 'requestCancel');

  let status = 'unconfirmed';

  if (hasRequestedCancel) {
    status = 'requestCancel';
  } else if (hasRequestedReschedule) {
    status = 'requestReschedule';
  } else if (hasClockOutConfirmationn) {
    status = 'clockOutConfirmation';
  } else if (hasClockInConfirmation) {
    status = 'clockInConfirmation';
  } else if (hasShiftConfirmation) {
    status = 'shiftConfirmation';
  }

  const styles = getStylesByStatus(status);

  return (
    <Box
      sx={{
        'background': styles.background,
        'borderRadius': 1,
        'p': 1,
        'pb': 0.5,
        'mb': 0,
        'borderLeft': `3px solid ${styles.borderColor}`,
        'cursor': 'pointer',
        'width': '100%',
        'height': '100%',
        'flexDirection': 'row',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          fontWeight: 'medium',
          color: styles.textColor,
          fontSize: '11px',
          flex: 1,
          mr: 1,
        }}
      >
        {event.info.title}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          opacity: 0.7,
          color: '#616161',
          display: 'flex',
          alignItems: 'center',
          fontSize: '10px',
          flexShrink: 0,
        }}
      >
        <AccessTimeIcon sx={{fontSize: '0.8rem', mr: 0.3}} />
        {startTime}
      </Typography>
    </Box>
  );
};

MonthlyEventTile.propTypes = {
  event: PropTypes.object.isRequired,
};

export default MonthlyEventTile;
